import React, { useState, useEffect } from 'react'
import Layout from '../Layout'
import IHRSectionone from './IHRSectionone'
import IHRIntro from './IHRIntro'
import IDBContactUsToday from '../IDBPage/IDBContactUsToday'
import IHRChoose from './IHRChoose';
import IHRServices from './IHRServices';
import IHRClients from './IHRClients'
import { IDBSectionfour } from '../IDBPage/IDBSectionfour'
import IHRSlider from './IHRSlider'
import AllSectionone from '../ReusableComp/Sectionone';
import * as Images from '../../assets';
import { fetchWithFormData } from '../../apiGeneralFunction'
import { trackCustomEvent } from '../../event_firebase';

const IntelligentHR = () => {

          const [data, setData] = useState([]);
      
        useEffect(() => {
      
          const formData = new FormData();
      
          fetchWithFormData(`intelligent_hr`, formData)
            // .then(data => setData(data[0].data))
            .then(data => {
              if (data?.status === true) {
                setData(data?.data);
                  trackCustomEvent('intelligent_hr', { status: true });
              }
              else {
                // console.error('Status is not true:', data?.status);
                setData("null");
                trackCustomEvent('intelligent_hr', { status: false });
              }
            })
            .catch(
            // error => console.error('Error fetching data:', error)
          );
      
        }, []);

  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);

  
  return (
    <Layout>
        {/* <IHRSectionone/> */}
        <AllSectionone
         src={Images.ihr_bg_new}
        // src={Images.make_my_business_bg}
        title={'Intelligent HR'}
        link_to2={'/our_services'}
        link_name2={'Our Services'}
        link_to3={'/intelligent_hr'}
        link_name3={'Intelligent HR'}
      />
        <IHRIntro/>
       <IHRServices data={data?.services} />
        <IHRChoose/>
        {/* <IHRClients/> */}
        {/* <IDBSectionfour/> */}
        {/* <IDBContactUsToday/> */}
    </Layout>
  )
}

export default IntelligentHR